    import React from "react";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
const ReferenceReviewPage = ({
  references,

  setScreen,
  onEditReferences,

  confirmReferences,
}) => {
  return (
    <section className="fw-screen fw-screen--reference-review fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <h1 className="fw-title fw-title--sm">
        Please review and confirm your reference details.
      </h1>

      <div className="fw-reference__scroll">
        {references.map((ref, index) => (
          <div
            key={`ref-summary-${index}`}
            className="fw-ref-summary"
          >
            <h2>
              Reference {index + 1} Summary
            </h2>

            <div className="fw-ref-summary__row">
              <span>Name</span>

              <strong>
                {ref.name}
              </strong>
            </div>

            <div className="fw-ref-summary__row">
              <span>Mobile Number</span>

              <strong>
                {ref.mobile}
              </strong>
            </div>

            <div className="fw-ref-summary__row">
              <span>Relation</span>

              <strong>
                {ref.relation}
              </strong>
            </div>
          </div>
        ))}
      </div>

      <div className="fw-actions fw-actions--review">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() => {
            if (typeof onEditReferences === "function") {
              onEditReferences();
            } else {
              setScreen("/apply-new/referenceDetails");
            }
          }}
        >
          Edit
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--dark"
          onClick={confirmReferences}
        >
          Confirm and Proceed
        </button>
      </div>
    </section>
  );
};

export default ReferenceReviewPage;